import { render } from "./PainelRelatorioVendasIndex.vue?vue&type=template&id=c060d63e&scoped=true&ts=true"
import script from "./PainelRelatorioVendasIndex.vue?vue&type=script&lang=ts"
export * from "./PainelRelatorioVendasIndex.vue?vue&type=script&lang=ts"

import "./PainelRelatorioVendasIndex.vue?vue&type=style&index=0&id=c060d63e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c060d63e"]])

export default __exports__